import React, { useContext, useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import { Can } from "../Can";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, Menu } from "@material-ui/core";
import {
  Network as DeviceHubOutlined,
  History,
  FileText as PictureAsPdf,
  RotateCcw as Replay,
} from "lucide-react";
import { v4 as uuidv4 } from "uuid";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
// import TicketOptionsMenu from "../TicketOptionsMenu";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";
import usePlans from "../../hooks/usePlans";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import Tooltip from '@material-ui/core/Tooltip';
import ConfirmationModal from "../ConfirmationModal";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Check as CheckLucide } from "lucide-react";
import CustomToggleSwitch from "../CustomToggleSwitch";
import TransferTicketModalCustom from "../TransferTicketModalCustom";
import AcceptTicketWithouSelectQueue from "../AcceptTicketWithoutQueueModal";
import ChatiaPopover, { PopoverOptionItem } from "../ChatiaPopover";

import {
  Languages as TranslateIcon,
  CircleX as ResolveIcon,
  Undo2 as ReturnQueueIcon,
  CornerUpRight as TransferTicketIcon,
  MoreVertical as MoreVertIcon,
  Tag as TagIcon,
  Kanban as KanbanIcon,
  Sparkles as AiSummaryIcon,
  FileText as LogTicketIcon,
  FileDown as ExportPdfIcon,
  Trash2 as DeleteTicketIcon,
  CheckCircle2 as ChatbotOnIcon,
  XCircle as ChatbotOffIcon,
} from "lucide-react";

const GreenSwitch = withStyles({
    root: {
        width: 36,
        height: 20,
        padding: 0,
        display: 'flex',
        overflow: 'visible',
    },
    switchBase: {
        padding: 2,
        color: '#fff !important',
        '&:hover': {
            backgroundColor: 'transparent !important',
        },
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#fff !important',
            '&:hover': {
                backgroundColor: 'transparent !important',
            },
            '& + $track': {
                opacity: '1 !important',
                backgroundColor: '#4caf50 !important',
            },
        },
    },
    thumb: {
        width: 16,
        height: 16,
        boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        backgroundColor: '#fff !important',
    },
    track: {
        borderRadius: 10,
        opacity: '1 !important',
        backgroundColor: '#9e9e9e !important',
    },
    checked: {},
})(Switch);

import ScheduleModal from "../ScheduleModal";
import MenuItem from "@material-ui/core/MenuItem";
import { Switch, withStyles } from "@material-ui/core";
import ShowTicketOpen from "../ShowTicketOpenModal";
import { toast } from "react-toastify";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import ShowTicketLogModal from "../ShowTicketLogModal";
import TicketMessagesDialog from "../TicketMessagesDialog";
import { useTheme } from "@material-ui/styles";
import { useMediaQuery } from "@material-ui/core";
import AiSummaryModal from "../AiSummaryModal";
import { TagsContainer } from "../TagsContainer";
import { TagsKanbanContainer } from "../TagsKanbanContainer";
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { X as CloseIcon } from "lucide-react";

const useStyles = makeStyles(theme => ({
    actionButtons: {
        marginRight: 6,
        maxWidth: "100%",
        flex: "none",
        alignSelf: "center",
        marginLeft: "auto",
        // flexBasis: "50%",
        display: "flex",
        "& > *": {
            margin: theme.spacing(1),
        },
    },
    bottomButtonVisibilityIcon: {
        padding: 1,
        color: theme.mode === "light" ? '#0872b9' : '#FFF',
        "&:hover": {
            backgroundColor: "transparent !important",
        },
        "& .MuiTouchRipple-root": {
            display: "none",
        },
    },
    botoes: {
        display: "flex",
        padding: "15px",
        justifyContent: "flex-end",
        maxWidth: "100%",
    },
    menuItem: {
        borderRadius: 7,
        "&:hover": {
            backgroundColor: "#f5f0eb !important",
        },
    },
}));

const SessionSchema = Yup.object().shape({
    ratingId: Yup.string().required(i18n.t("validationResponsive.ratingRequired")),
});

const useAcceptButtonStyles = makeStyles((theme) => ({
    accept: {
        minWidth: 110,
        height: 36,
        paddingLeft: 14,
        paddingRight: 14,
        backgroundColor: `${theme.palette.primary.main} !important`,
        color: `${theme.palette.getContrastText
            ? theme.palette.getContrastText(theme.palette.primary.main)
            : "#fff"} !important`,
        "& .MuiButton-label": {
            color: "inherit",
        },
        "& .MuiButton-startIcon, & svg": {
            color: "inherit",
        },
        "&:hover": {
            backgroundColor: `${theme.palette.primary.dark || theme.palette.primary.main} !important`,
            filter: "none !important",
            color: `${theme.palette.getContrastText
                ? theme.palette.getContrastText(theme.palette.primary.dark || theme.palette.primary.main)
                : "#fff"} !important`,
        },
        "&.Mui-disabled": {
            backgroundColor: `${theme.palette.primary.main} !important`,
            color: `${theme.palette.getContrastText
                ? theme.palette.getContrastText(theme.palette.primary.main)
                : "#fff"} !important`,
            opacity: 0.7,
        },
    },
}));

const AcceptButton = ({ loading, onClick, children }) => {
    const cls = useAcceptButtonStyles();
    return (
        <Button
            variant="contained"
            onClick={onClick}
            disabled={loading}
            size="small"
            className={cls.accept}
            startIcon={loading
                ? <CircularProgress size={14} color="inherit" />
                : <CheckLucide size={16} />}
        >
            {children}
        </Button>
    );
};

const TicketActionButtonsCustom = ({ ticket
    // , showSelectMessageCheckbox,
    // selectedMessages,
    // forwardMessageModalOpen,
    // setForwardMessageModalOpen
}) => {
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const history = useHistory();
    const [isMounted, setIsMounted] = useState(true);
    const [loading, setLoading] = useState(false);
    const { user } = useContext(AuthContext);
    const { setCurrentTicket, setTabOpen } = useContext(TicketsContext);
    const [open, setOpen] = React.useState(false);
    const formRef = React.useRef(null);
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
    const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
    const [contactId, setContactId] = useState(null);
    const [acceptTicketWithouSelectQueueOpen, setAcceptTicketWithouSelectQueueOpen] = useState(false);
    const [showTicketLogOpen, setShowTicketLogOpen] = useState(false);
    const [openTicketMessageDialog, setOpenTicketMessageDialog] = useState(false);
    // botActive = bot/IA está ativo para este contato
    const [botActive, setBotActive] = useState(!ticket.contact.disableBot);
    const [contactTranslate, setContactTranslate] = useState(!!ticket.contact.language);

    const [showSchedules, setShowSchedules] = useState(false);
    const [enableIntegration, setEnableIntegration] = useState(ticket.useIntegration);

    const [openAlert, setOpenAlert] = useState(false);
    const [userTicketOpen, setUserTicketOpen] = useState("");
    const [queueTicketOpen, setQueueTicketOpen] = useState("");
    const [aiSummaryModalOpen, setAiSummaryModalOpen] = useState(false);
    const [tagsAnchorEl, setTagsAnchorEl] = useState(null);
    const [kanbanAnchorEl, setKanbanAnchorEl] = useState(null);
    const [resolveAnchorEl, setResolveAnchorEl] = useState(null);
    const [logTicket, setLogTicket] = useState([]);

    const { get: getSetting } = useCompanySettings()
    const { getPlanCompany } = usePlans();


    const [anchorEl, setAnchorEl] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        fetchData();

        // Cleanup function to set isMounted to false when the component unmounts
        return () => {
            setIsMounted(false);
        };
    }, []);

    // Sincronizar estado do bot quando o contato muda
    useEffect(() => {
        setBotActive(!ticket.contact?.disableBot);
    }, [ticket?.contact?.disableBot]);


    const fetchData = async () => {
        const companyId = user.companyId;
        const planConfigs = await getPlanCompany(undefined, companyId);
        if (planConfigs && planConfigs.plan) {
            setShowSchedules(planConfigs.plan.useSchedules);
        }
        setOpenTicketMessageDialog(false);
        setBotActive(!!ticket.lastFlowId && !ticket.contact.disableBot);

        setShowTicketLogOpen(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }

    const handleClickOpen = async (e) => {
        const target = e.currentTarget;
        const setting = await getSetting({
            "column": "requiredTag"
        });

        if (setting?.requiredTag === "enabled") {
            try {
                const contactTags = await api.get(`/contactTags/${ticket.contact.id}`);
                if (!contactTags.data.tags) {
                    toast.warning(i18n.t("messagesList.header.buttons.requiredTag"))
                } else {
                    setResolveAnchorEl(target);
                }
            } catch (err) {
                toastError(err);
            }
        } else {
            setResolveAnchorEl(target);
        }
    };

    const handleClose = () => {
        formRef.current.resetForm();
        setOpen(false);
    };

    const handleCloseAlert = () => {
        setOpenAlert(false);
        setLoading(false);
    };
    const handleOpenAcceptTicketWithouSelectQueue = async () => {

        setAcceptTicketWithouSelectQueueOpen(true);

    };

    const handleMenu = event => {
        setAnchorEl(event.currentTarget);
        setMenuOpen(true);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
        setMenuOpen(false);
    };

    const handleOpenTransferModal = (e) => {
        setTransferTicketModalOpen(true);
        if (typeof handleClose == "function") handleClose();
    };

    const handleOpenConfirmationModal = (e) => {
        setConfirmationOpen(true);
        if (typeof handleClose == "function") handleClose();
    };


    const handleCloseTicketWithoutFarewellMsg = async () => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: "closed",
                userId: user?.id || null,
                sendFarewellMessage: false,
                amountUsedBotQueues: 0
            });

            setLoading(false);
            history.push("/tickets");
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };

    const handleExportPDF = async () => {
        setOpenTicketMessageDialog(true);
        handleCloseMenu();
    }

    const handleEnableIntegration = async () => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                useIntegration: !enableIntegration
            });
            setEnableIntegration(!enableIntegration)

            setLoading(false);
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };

    const handleShowLogTicket = async () => {
        setShowTicketLogOpen(true);
    };

    const handleContactToggleDisableBot = async () => {
        const { id } = ticket.contact;

        try {
            const { data } = await api.put(`/contacts/toggleDisableBot/${id}`);
            ticket.contact.disableBot = data.disableBot;
            setBotActive(!data.disableBot);
        } catch (err) {
            toastError(err);
        }
    };

    const handleToggleContactTranslate = async () => {
        const { id } = ticket.contact;
        try {
            const { data } = await api.put(`/contacts/toggleTranslate/${id}`, {
                ticketId: ticket.id
            });
            const enabled = !!data.language;
            setContactTranslate(enabled);
            ticket.contact.language = data.language;
            toast.success(
                enabled
                    ? i18n.t("messagesList.header.buttons.translateEnabled")
                    : i18n.t("messagesList.header.buttons.translateDisabled")
            );
        } catch (err) {
            toastError(err);
        }
    };

    const handleCloseTransferTicketModal = () => {
        setTransferTicketModalOpen(false);
    };

    const handleDeleteTicket = async () => {
        try {
            await api.delete(`/tickets/${ticket.id}`);
            history.push("/tickets")
        } catch (err) {
            toastError(err);
        }
    };

    const handleSendMessage = async (id) => {
        let setting;

        try {
            setting = await getSetting({
                "column": "greetingAcceptedMessage"
            })
        } catch (err) {
            toastError(err);
        }
        const msg = `${setting.greetingAcceptedMessage}`; //`{{ms}} *{{name}}*, ${i18n.t("mainDrawer.appBar.user.myName")} *${user?.name}* ${i18n.t("mainDrawer.appBar.user.continuity")}.`;
        const message = {
            read: 1,
            fromMe: true,
            mediaUrl: "",
            body: `${msg.trim()}`,
        };
        try {
            await api.post(`/messages/${id}`, message);
        } catch (err) {
            toastError(err);
        }
    };


    const handleUpdateTicketStatus = async (e, status, userId) => {
        setLoading(true);
        try {
            await api.put(`/tickets/${ticket.id}`, {
                status: status,
                queueId: ticket?.queueId || ticket?.queue?.id || null,
                userId: userId || null,
            });

            let setting;

            try {
                setting = await getSetting({
                    "column": "sendGreetingAccepted"
                })
            } catch (err) {
                toastError(err);
            }

            if (setting?.sendGreetingAccepted === "enabled" && (!ticket.isGroup || ticket.whatsapp?.groupAsTicket === "enabled") && ticket.status === "pending") {
                handleSendMessage(ticket.id);
            }


            // if (isMounted.current) {
            setLoading(false);
            // }
            if (status === "open" || status === "group") {
                setCurrentTicket({ ...ticket, code: "#" + status });
                // handleSelectTicket(ticket);
                setTimeout(() => {
                    history.push('/tickets');
                }, 0);

                setTimeout(() => {
                    history.push(`/tickets/${ticket.uuid}`);
                    setTabOpen(status)
                }, 10);


            } else {
                setCurrentTicket({ id: null, code: null })
                history.push("/tickets");

            }
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };

    const handleAcepptTicket = async (id) => {
        setLoading(true);
        try {
            const otherTicket = await api.put(`/tickets/${id}`, {
                status: ticket.isGroup ? "group" : "open",
                userId: user?.id,
                queueId: ticket?.queueId || ticket?.queue?.id || null,
            });
            if (otherTicket.data.id !== ticket.id) {
                if (otherTicket.data.userId !== user?.id) {
                    setOpenAlert(true)
                    setUserTicketOpen(otherTicket.data.user.name)
                    setQueueTicketOpen(otherTicket.data.queue.name)
                    setTabOpen(otherTicket.isGroup ? "group" : "open")
                } else {
                    setLoading(false);
                    // handleSelectTicket(otherTicket.data);
                    setTabOpen(otherTicket.isGroup ? "group" : "open")

                    history.push(`/tickets/${otherTicket.data.uuid}`);
                }
            } else {
                // if (isMounted.current) {
                setLoading(false);
                // }

                // handleSelectTicket(ticket);
                history.push('/tickets');
                setTimeout(() => {
                    history.push(`/tickets/${ticket.uuid}`);
                    setTabOpen(ticket.isGroup ? "group" : "open")
                }, 1000)
            }
        } catch (err) {
            setLoading(false);
            toastError(err);
        }
    };

    return (
        <>
            {openAlert && (
                <ShowTicketOpen
                    isOpen={openAlert}
                    handleClose={handleCloseAlert}
                    user={userTicketOpen}
                    queue={queueTicketOpen}
                />
            )}
            {acceptTicketWithouSelectQueueOpen && (
                <AcceptTicketWithouSelectQueue
                    modalOpen={acceptTicketWithouSelectQueueOpen}
                    onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
                    ticketId={ticket.id}
                    ticket={ticket}
                />
            )}
            {showTicketLogOpen && (
                <ShowTicketLogModal
                    isOpen={showTicketLogOpen}
                    handleClose={(e) => setShowTicketLogOpen(false)}
                    ticketId={ticket.id}
                />
            )}
            {openTicketMessageDialog && (
                <TicketMessagesDialog
                    open={openTicketMessageDialog}
                    handleClose={() => setOpenTicketMessageDialog(false)}
                    ticketId={ticket.id}
                />
            )}
            {aiSummaryModalOpen && (
                <AiSummaryModal
                    open={aiSummaryModalOpen}
                    onClose={() => setAiSummaryModalOpen(false)}
                    ticketId={ticket.id}
                />
            )}
            <div className={classes.actionButtons}>
                {ticket.status === "closed" && (ticket.queueId === null || ticket.queueId === undefined) && (
                    <ButtonWithSpinner
                        loading={loading}
                        startIcon={<Replay />}
                        size="small"
                        onClick={e => handleOpenAcceptTicketWithouSelectQueue()}
                    >
                        {i18n.t("messagesList.header.buttons.reopen")}
                    </ButtonWithSpinner>
                )}
                {(ticket.status === "closed" && ticket.queueId !== null) && (
                    <ButtonWithSpinner
                        startIcon={<Replay />}
                        loading={loading}
                        onClick={e => handleAcepptTicket(ticket.id)}
                    >
                        {i18n.t("messagesList.header.buttons.reopen")}
                    </ButtonWithSpinner>
                )}
                {/* <IconButton
                    className={classes.bottomButtonVisibilityIcon}
                    onClick={handleShowLogTicket}
                >
                    <Tooltip title={i18n.t("messagesList.header.buttons.logTicket")}>
                        <History />

                    </Tooltip>
                </IconButton> */}
                {(ticket.status === "open" || ticket.status === "group") && (
                    <>
                        {/* Desktop: ícones diretos */}
                        {!isMobile && (
                            <>
                                <Tooltip title={i18n.t("messagesList.header.buttons.kanban")}>
                                    <IconButton disableRipple className={classes.bottomButtonVisibilityIcon} onClick={(e) => setKanbanAnchorEl(e.currentTarget)}>
                                        <KanbanIcon size={18} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={i18n.t("messagesList.header.buttons.tags")}>
                                    <IconButton disableRipple className={classes.bottomButtonVisibilityIcon} onClick={(e) => setTagsAnchorEl(e.currentTarget)}>
                                        <TagIcon size={18} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={contactTranslate ? i18n.t("messagesList.header.buttons.disableTranslate") : i18n.t("messagesList.header.buttons.enableTranslate")}>
                                    <IconButton disableRipple className={classes.bottomButtonVisibilityIcon} onClick={handleToggleContactTranslate}>
                                        <TranslateIcon size={18} style={contactTranslate ? { color: "#1e3a5f" } : {}} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={i18n.t("messagesList.header.buttons.aiSummaries")}>
                                    <IconButton disableRipple className={classes.bottomButtonVisibilityIcon} onClick={() => setAiSummaryModalOpen(true)}>
                                        <AiSummaryIcon size={18} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={i18n.t("messagesList.header.buttons.resolve")}>
                                    <IconButton disableRipple className={classes.bottomButtonVisibilityIcon} onClick={(e) => { e.persist && e.persist(); handleClickOpen(e); }}>
                                        <ResolveIcon size={18} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={i18n.t("tickets.buttons.returnQueue")}>
                                    <IconButton disableRipple className={classes.bottomButtonVisibilityIcon} onClick={(e) => handleUpdateTicketStatus(e, "pending", null)}>
                                        <ReturnQueueIcon size={18} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={i18n.t("ticketsResponsive.actions.transferTicket")}>
                                    <IconButton disableRipple className={classes.bottomButtonVisibilityIcon} onClick={handleOpenTransferModal}>
                                        <TransferTicketIcon size={18} />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )}

                        {confirmationOpen && (
                            <ConfirmationModal
                                title={`${i18n.t("ticketOptionsMenu.confirmationModal.title")} #${ticket.id}?`}
                                open={confirmationOpen}
                                onClose={setConfirmationOpen}
                                onConfirm={handleDeleteTicket}
                            >
                                {i18n.t("ticketOptionsMenu.confirmationModal.message")}
                            </ConfirmationModal>
                        )}
                        {transferTicketModalOpen && (
                            <TransferTicketModalCustom
                                modalOpen={transferTicketModalOpen}
                                onClose={handleCloseTransferTicketModal}
                                ticketid={ticket.id}
                                ticket={ticket}
                            />
                        )}
                    </>
                )}
                {!isMobile && (
                    <Tooltip title={botActive ? i18n.t("messagesList.header.buttons.chatbotActive") : i18n.t("messagesList.header.buttons.chatbotInactive")}>
                        <div style={{ display: "inline-flex", alignItems: "center", padding: "0 8px" }}>
                            <CustomToggleSwitch
                                checked={botActive}
                                onChange={() => handleContactToggleDisableBot()}
                            />
                        </div>
                    </Tooltip>
                )}
                {ticket.status === "pending" && (ticket.queueId === null || ticket.queueId === undefined) && (
                    <AcceptButton loading={loading} onClick={e => handleOpenAcceptTicketWithouSelectQueue()}>
                        {i18n.t("messagesList.header.buttons.accept")}
                    </AcceptButton>
                )}
                {ticket.status === "pending" && ticket.queueId !== null && (
                    <AcceptButton loading={loading} onClick={e => handleUpdateTicketStatus(e, "open", user?.id)}>
                        {i18n.t("messagesList.header.buttons.accept")}
                    </AcceptButton>
                )}
                <IconButton
                    disableRipple
                    onClick={handleMenu}
                    color="inherit"
                    style={{ padding: 6, backgroundColor: 'transparent' }}
                >
                    <MoreVertIcon size={18} />
                </IconButton>
                <ChatiaPopover
                    open={menuOpen}
                    anchorEl={anchorEl}
                    onClose={handleCloseMenu}
                    title={i18n.t("messagesList.header.buttons.options")}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    {/* Mobile: todas as ações no popover */}
                    {isMobile && (ticket.status === "open" || ticket.status === "group") && (
                        <>
                            <PopoverOptionItem
                                icon={<ResolveIcon size={18} />}
                                label={i18n.t("messagesList.header.buttons.resolve")}
                                onClick={(e) => { handleCloseMenu(); handleClickOpen(e); }}
                            />
                            <PopoverOptionItem
                                icon={<ReturnQueueIcon size={18} />}
                                label={i18n.t("tickets.buttons.returnQueue")}
                                onClick={(e) => { handleCloseMenu(); handleUpdateTicketStatus(e, "pending", null); }}
                            />
                            <PopoverOptionItem
                                icon={<TransferTicketIcon size={18} />}
                                label={i18n.t("ticketsResponsive.actions.transferTicket")}
                                onClick={() => { handleCloseMenu(); handleOpenTransferModal(); }}
                            />
                            <PopoverOptionItem
                                icon={<KanbanIcon size={18} />}
                                label={i18n.t("messagesList.header.buttons.kanban")}
                                onClick={(e) => { handleCloseMenu(); setKanbanAnchorEl(e.currentTarget); }}
                            />
                            <PopoverOptionItem
                                icon={<TagIcon size={18} />}
                                label={i18n.t("messagesList.header.buttons.tags")}
                                onClick={(e) => { handleCloseMenu(); setTagsAnchorEl(e.currentTarget); }}
                            />
                            <PopoverOptionItem
                                icon={<TranslateIcon size={18} style={contactTranslate ? { color: "#1e3a5f" } : {}} />}
                                label={contactTranslate ? i18n.t("messagesList.header.buttons.disableTranslate") : i18n.t("messagesList.header.buttons.enableTranslate")}
                                onClick={() => { handleCloseMenu(); handleToggleContactTranslate(); }}
                            />
                            <PopoverOptionItem
                                icon={<AiSummaryIcon size={18} />}
                                label={i18n.t("messagesList.header.buttons.aiSummaries")}
                                onClick={() => { handleCloseMenu(); setAiSummaryModalOpen(true); }}
                            />
                            <PopoverOptionItem
                                icon={botActive
                                    ? <ChatbotOnIcon size={18} color="#4caf50" />
                                    : <ChatbotOffIcon size={18} />
                                }
                                label={botActive ? i18n.t("messagesList.header.buttons.disableChatbot") : i18n.t("messagesList.header.buttons.enableChatbot")}
                                onClick={() => { handleCloseMenu(); handleContactToggleDisableBot(); }}
                            />
                        </>
                    )}
                    {/* Opções comuns (desktop e mobile) */}
                    <PopoverOptionItem
                        icon={<LogTicketIcon size={18} />}
                        label={i18n.t("messagesList.header.buttons.logTicket")}
                        onClick={() => { handleCloseMenu(); handleShowLogTicket(); }}
                    />
                    <PopoverOptionItem
                        icon={<ExportPdfIcon size={18} />}
                        label={i18n.t("ticketsList.buttons.exportAsPDF")}
                        onClick={() => { handleCloseMenu(); handleExportPDF(); }}
                    />
                    <Can
                        role={user.profile}
                        perform="ticket-options:deleteTicket"
                        yes={() => (
                            <PopoverOptionItem
                                icon={<DeleteTicketIcon size={18} color="#e53935" />}
                                label={i18n.t("tickets.buttons.deleteTicket")}
                                onClick={() => { handleCloseMenu(); handleOpenConfirmationModal(); }}
                            />
                        )}
                    />
                </ChatiaPopover>
            </div>
            <ChatiaPopover
                open={Boolean(tagsAnchorEl)}
                anchorEl={tagsAnchorEl}
                onClose={() => setTagsAnchorEl(null)}
                title={i18n.t("messagesList.header.buttons.tags")}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <div style={{ minWidth: 280, padding: "8px 6px" }}>
                    <TagsContainer contact={ticket.contact} />
                </div>
            </ChatiaPopover>
            <ChatiaPopover
                open={Boolean(kanbanAnchorEl)}
                anchorEl={kanbanAnchorEl}
                onClose={() => setKanbanAnchorEl(null)}
                title={i18n.t("messagesList.header.buttons.kanban")}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <div style={{ minWidth: 280, padding: "8px 6px" }}>
                    <TagsKanbanContainer ticket={ticket} />
                </div>
            </ChatiaPopover>
            <ChatiaPopover
                open={Boolean(resolveAnchorEl)}
                anchorEl={resolveAnchorEl}
                onClose={() => setResolveAnchorEl(null)}
                title={i18n.t("messagesList.header.buttons.resolve")}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <PopoverOptionItem
                    label={i18n.t("messagesList.header.dialogRatingWithoutFarewellMsg")}
                    onClick={() => { setResolveAnchorEl(null); handleCloseTicketWithoutFarewellMsg(); }}
                />
                <PopoverOptionItem
                    label={i18n.t("messagesList.header.dialogRatingCancel")}
                    onClick={(e) => { setResolveAnchorEl(null); handleUpdateTicketStatus(e, "closed", user?.id, ticket?.queue?.id); }}
                />
            </ChatiaPopover>
        </>
    );
};

export default TicketActionButtonsCustom;
